import React, { useContext, useEffect, useState } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import CashierApi from "../../utility/CashierApi";
import DeleteDraft from "./DeleteDraft";
import { CustomerContext } from "../CashierHomepage";
import { CustomerIdContext } from "../../context/CustomerIdProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import loader from "../../assets/loader.webp";
import { formatDateTime } from "../../components/formatDateTime";

function AllDraftModal({ handleClose, open, draft, setOpenDraft, isLoading }) {
  const { fetchPinData } = CashierApi();

  const queryClient = useQueryClient();
  const {
    setSelectedCustomerName,
    setUpdateResumeStatus,
    setDraftId,
    currency,
  } = useContext(CustomerContext);
  const { setSelectedCustomerId } = useContext(CustomerIdContext);
  const [orderId, setOrderId] = useState(null);

  const resumeCartMutation = useMutation({
    mutationFn: (orderId) => fetchPinData(`orders/resume-order/${orderId}`),
    onSuccess: async () => {
      // console.log("mutation succeeded:");
      await queryClient.invalidateQueries({ queryKey: ["cart"] });
      setOpenDraft(false);
    },
    onError: (error) => {
      console.error("Query failed:", error); // Log any errors
    },
  });

  useEffect(() => {
    if (!open) {
      setOrderId(null);
    }
  }, [open]);

  const handleEditDraft = (id, customerId, name) => {
    resumeCartMutation.mutate(id);
    setDraftId(id);
    setSelectedCustomerId(customerId);
    setSelectedCustomerName(name);
    setUpdateResumeStatus(true);

    // console.log(id, customerId);
  };

  // console.log("Query Debugging -> orderId:", orderId);

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center  bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 h-4/6  ">
        <div className="flex justify-end">
          <CancelIcon
            onClick={() => handleClose(true)}
            className="cursor-pointer text-black mb-2"
          />
        </div>
        {isLoading ? (
          <div className="flex h-full justify-center w-72 items-center">
            <img src={loader} alt="loader" className="w-8" />
          </div>
        ) : (
          <div className="text-black h-[95%] shadow-lg pb-2 overflow-y-auto">
            <table className="min-w-full  border border-gray-300">
              <thead>
                <tr
                // className="bg-gray-200"
                >
                  <th className="py-2 px-1 border-b border-gray-300">#</th>
                  <th className="py-2 px-2 border-b border-gray-300">
                    Order No
                  </th>
                  <th className="py-2 px-2 border-b border-gray-300">
                    Customer name
                  </th>
                  <th className="py-2 px-2 border-b border-gray-300">Total</th>
                  <th className="py-2 px-2 border-b border-gray-300">Time </th>
                  <th className="py-2 px-2 border-b border-gray-300 text-wrap">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="overflow-y-auto max-h-60">
                {draft?.map((item, index) => (
                  <tr
                    onClick={() =>
                      handleEditDraft(
                        item.id,
                        item.customer_id,
                        item?.customer?.name
                      )
                    }
                    key={item.id}
                    className="hover:bg-gray-200 border-b border-gray-300 cursor-pointer"
                  >
                    <td className="py-2 px-4 text-center text-wrap">
                      {index + 1}
                    </td>

                    <td className="py-2 px-4 text-center text-wrap">
                      {item?.orderNO}
                    </td>
                    <td className="py-2 px-4 text-center text-wrap">
                      {item?.customer?.name}
                    </td>
                    <td className="py-2 px-4 text-center text-wrap">
                      {currency}
                      {item?.total_price}
                    </td>
                    <td className="py-2 px-4 text-center text-wrap">
                      {formatDateTime(item?.updated_at)}
                    </td>
                    <td className="py-2 px-4 text-center justify-center flex gap-3">
                      <DeleteDraft itemId={item.id} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default AllDraftModal;
